/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Output_TitleInputs */

const es_prompt_tips_output_title = /** @type {(inputs: Prompt_Tips_Output_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sé concreto con el resultado esperado`)
};

const en_prompt_tips_output_title = /** @type {(inputs: Prompt_Tips_Output_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Be specific about the expected output`)
};

/**
* | output |
* | --- |
* | "Be specific about the expected output" |
*
* @param {Prompt_Tips_Output_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_output_title = /** @type {((inputs?: Prompt_Tips_Output_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Output_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_output_title(inputs)
	return en_prompt_tips_output_title(inputs)
});
export { prompt_tips_output_title as "prompt_tips.output_title" }